const Plus = ({ className }) => {
  return (

<svg id="fi_9312231" className={className} enableBackground="new 0 0 512 512" height="23" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><g><g><path d="m256 439.98c-13.81 0-25-11.19-25-25v-317.96c0-13.81 11.19-25 25-25s25 11.19 25 25v317.96c0 13.81-11.19 25-25 25z"></path></g><g><path d="m414.98 281h-317.96c-13.81 0-25-11.19-25-25s11.19-25 25-25h317.96c13.81 0 25 11.19 25 25s-11.19 25-25 25z"></path></g></g></svg>

  );
};

export default Plus;
